import { facebook, instagram, linkedin, www ,star,shield,send,nice,writing ,bullseye,teacher,mano,smirk} from "../assets";
import {
  benefitIcon1,
  benefitIcon2,
  benefitIcon3,
  benefitIcon4,
  benefitImage2,
  chromecast,
  disc02,
  discordBlack,
  file02,
  homeSmile,
  notification2,
  notification3,
  notification4,
  plusSquare,
  recording01,
  recording03,
  roadmap1,
  roadmap2,
  roadmap3,
  roadmap4,
  searchMd,
  sliders04,
  telegram,
  twitter,
  ielts,
  toefl,
  cambridge
} from "../assets2";

export const navLinksSDS = [
  { title: "Home", path: "/" },
 
  { title: "Library",       path: "/Store" },
  { title: "Team",       path: "/Team" },

  // Dropdowns
 
  {
    title: "About",
    subLinks: [
      { title: "Info",       path: "/Precios"
      },
      {
        title: "Extra",
        path: "/PoliticasClase"
      },
      // Otras subopciones de Roadmaps
    ],
  }, {
    title: "Rutas",
    subLinks: [
      { title: "A1 Movers",       path: "/RoadMapA1"     },

      { title: "A2 KEY",       path: "/RoadMap"     },
      { title: "B1 PET",       path: "/RoadMapB1"     },

      { title: "B2 FCE",       path: "/RoadMapB2"     },
      { title: "C1 CAE", path: "/RoadMapC1"    },
      // Otras subopciones de Roadmaps
    ],
  },
  {
    title: "Inglés Profesional",
    subLinks: [
      { title: "Business",path: "/RoadMapBusiness" },
      { title: "Health",       path: "/RoadMapHealth" },
      { title: "Tech",       path: "/RoadMapTech" },
      { title: "cELPIP",       path: "/Celpip" },
      {
        title: "French",
        path: "/RoadMapFrench"
        
      },
      {
        title: "Bootcamp",
        path: "/Bootcamp"
        
      }
      
    
    ],
  },
];
export const navLinks = [
  { title: "Home", path: "/" },
 
  { title: "Library",       path: "/Store" },
  { title: "Team",       path: "/Team" },

  // Dropdowns
 
  {
    title: "About",
    subLinks: [
      { title: "Info",       path: "/Precios"
      },
      {
        title: "Extra",
        path: "/PoliticasClase"
      },
      // Otras subopciones de Roadmaps
    ],
  }, 
  
];

  export const footerLinks = [
    {
      title: "Useful Links",
      links: [
        {
          name: "Content",
          link: "https://www.hoobank.com/content/",
        },
        {
          name: "How it Works",
          link: "https://www.hoobank.com/how-it-works/",
        },
        {
          name: "Create",
          link: "https://www.hoobank.com/create/",
        },
        {
          name: "Explore",
          link: "https://www.hoobank.com/explore/",
        },
        {
          name: "Terms & Services",
          link: "https://www.hoobank.com/terms-and-services/",
        },
      ],
    },
    {
      title: "Community",
      links: [
        {
          name: "Help Center",
          link: "https://www.hoobank.com/help-center/",
        },
        {
          name: "Partners",
          link: "https://www.hoobank.com/partners/",
        },
        {
          name: "Suggestions",
          link: "https://www.hoobank.com/suggestions/",
        },
        {
          name: "Library",
          link: "https://ucollege-meb.vercel.app/Store",
        },
        {
          name: "Prices",
          link: "https://ucollege-meb.vercel.app/Store",
        },
      ],
    },
    {
      title: "Partner",
      links: [
        {
          name: "Our Partner",
          link: "https://www.hoobank.com/our-partner/",
        },
        {
          name: "Become a Partner",
          link: "https://www.hoobank.com/become-a-partner/",
        },
      ],
    },
  ];
  
  export const socialMedia = [
    {
      id: "social-media-1",
      icon: instagram,
      link: "https://www.instagram.com/",
    },
    {
      id: "social-media-2",
      icon: facebook,
      link: "https://www.facebook.com/",
    },
    {
      id: "social-media-3",
      icon: www,
      link: "https://ucollege-meb.vercel.app/Store",
    },
    {
      id: "social-media-4",
      icon: linkedin,
      link: "https://www.linkedin.com/",
    },
  ];

  export const stats = [
    {
      id: "stats-1",
      title: "Autodidacta",
      value: "RoadMap ",
      img:writing
    },
    {
      id: "stats-2",
      title: "Estudiantes ",
      value: "2604  ",
      img:nice
    },
    {
      id: "stats-3",
      title: "Nos Recomienda",
      value: "98%  ",
      img:bullseye
    },
  ];

  export const features = [
    {
      id: "feature-1",
      icon: teacher,
      title: "Clases en Vivo11 y Asesoramiento Constante",
      content: "aaaaaenfocado en las 4 habilidades speaking,listening ,reading and writing. Te explicaré a detalle conceptos gramaticales para poder comprender los ejercicios que vendrán en el examen , de esta forma te aseguras tener un dominio antes de tomar el examen  ",
    },
    {
      id: "feature-2",
      icon: mano,
      title: "Roadmap",
      content: "Encontrarás material educativo para repasar , simulacros de exámenes anteriores, material enfocado en listening ,speaking en writing todo centrado en aprender en el menor tiempo posible  ",
    },
    {
      id: "feature-3",
      icon: smirk,
      title: "After class",
      content:
        "Son  clases donde harás preguntas sobre alguna clase anterior o pregunta externa que tengas ",
    },
  ];
  export const features2 = [
    {
      id: "feature-1",
      icon: teacher,
      title: "xxxx",
      content: "Todasssss tus clases son personalizadas de acuerdo a tu nivel , responderé todas tus preguntas y te brindare todos los recursos necesario para poder hablar el ingles como un nativo ",
    },
    {
      id: "feature-2",
      icon: mano,
      title: "Roadmapaaaa",
      content: "Encontrarás material educativo para repasar o adelantarte ",
    },
    {
      id: "feature-3",
      icon: smirk,
      title: "After class",
      content:
        "Son clases adicionales a tu paquete de clases donde resolveré todas tus preguntas",
    },
  ];

  export const features3 = [
    {
      id: "feature-1",
      icon: teacher,
      title: "Clases3 en Vivo y Asesoramiento Constante",
      content: "Todas tus clases son personalizadas de acuerdo a tu nivel , responderé todas tus preguntas y te brindare todos los recursos necesario para poder hablar el ingles como un nativo ",
    },
    {
      id: "feature-3",
      icon: mano,
      title: "Roadmapsss",
      content: "Encontrarás material educativo para repasar o adelantarte ",
    },
    {
      id: "feature-3",
      icon: smirk,
      title: "After class",
      content:
        "Son clases adicionales a tu paquete de clases donde resolveré todas tus preguntas",
    },
  ];

  export const politicas = [
    {
      id: "politica-1",
      icon: star,
      title: "¿Puedo cambiar o cancelar mi clase programada?",
      content: " ¡Sí! Si no puedes asistir a la clase programada, cancélala con al menos 24 horas de anticipación.Entonces podrás programar otra clase para ese mismo día o para otro día de la misma semana. Alternativamente, puedes llamar inmediatamente a uno de los excelentes tutores que están en línea +51 926 922 032",
    },
    {
      id: "politica-2",
      icon: shield,
      title: "Ten en cuenta",
      content: "Siempre queremos recordar que tanto los estudiantes como los tutores deben valorar el tiempo de cada uno ⏰. Cuando reservas una clase, el tutor se prepara con anticipación para enseñarte y asegurarse de que tengas la mejor experiencia de aprendizaje posible 📚. Si cancelas una clase sin previo aviso, le estás dejando en el aire y eso puede ser una pérdida para ambos. Sin embargo, si cancelas con al menos 24 horas de anticipación, el tutor tendrá la posibilidad de trabajar con otro alumno y tú podrás volver a utilizar esos minutos en una clase futura 🤝."
    },{
      id: "politica-3",
      icon: send,
      title: "Mi tutor no llegó a la lección 🤔❌",
      content:" Lamentamos mucho que tu tutor no pudo asistir a tu clase programada. Sabemos que esto puede ser frustrante, pero debes recordar que los tutores también son seres humanos y pueden tener imprevistos personales o técnicos que los impidan llegar a tu lección a tiempo.Recuerda que en nuestro servicio, tú eres nuestra prioridad y haremos todo lo posible para asegurarnos de que recibas la mejor experiencia de aprendizaje. 🤗",   
     },{
      id: "politica-4",
      icon: send,
      title: "¿Qué ocurre si no asisto a mi reserva? 🤔❌",
      content:"Cuando haces una reserva, te comprometes a asistir a esa lección. Entendemos que las emergencias surgen y que hay muchas razones por las que un estudiante puede tener que perder una lección inesperadamente.Si resulta que no vas a poder asistir a tu lección programada, por favor, cancélala al menos con 24 horas de antelación.Después, puedes programar una nueva lección para el horario que más te convenga",   
     },
     {
      id: "politica-5",
      icon: send,
      title: "Plazo para agendar ",
      content:"Cuando haces una reserva, te comprometes a asistir a esa lección. Entendemos que las emergencias surgen y que hay muchas razones por las que un estudiante puede tener que perder una lección inesperadamente.Si resulta que no vas a poder asistir a tu lección programada, por favor, cancélala al menos con 24 horas de antelación.Después, puedes programar una nueva lección para el horario que más te convenga",   
     }

  ];
  export const notificationImages = [notification4, notification3, notification2];

  export const heroIcons = [homeSmile, file02, searchMd, plusSquare];

  export const companyLogos = [cambridge, ielts, toefl];
  export const benefits = [
    {
      id: "0",
      title: "B2 First Cambridge Preparation - Grupal",
      text: "Clases los Sábados y Domingos de 4:00 a 6:00 pm , si quieres alcanzar el nivel B2 en inglés y además prepararte para este examen ,este grupo es ideal para ti ",
      price: "S/180 - $50 - MXN $ 930",

      backgroundUrl: "./src/assets/benefits/card-1.svg",
      iconUrl: benefitIcon1,
      imageUrl: benefitImage2,
    },
    {
      id: "1",
      title: "Asesoría de Inglés Personalizado",
      text: "Si quieres aprender inglés desde cero , cualquier nivel o quieres llevar clases a tu propio ritmo pero con alguien que te diga como mejorar más rápido. Ya sea con amigos o de forma individual sea cual sea tu objetivos , por diversión, trabajo , becas o ciudadanía esto es para ti!",
      price: "S/28",

      backgroundUrl: "./src/assets/benefits/card-2.svg",
      iconUrl: benefitIcon2,
      imageUrl: benefitImage2,
      light: true,
    },
    {
      id: "2",
      title: "Connect everywhere",
      text: "Connect with the AI chatbot from anywhere, on any device, making it more accessible and convenient.",
      price: "S/30",

      backgroundUrl: "./src/assets/benefits/card-3.svg",
      iconUrl: benefitIcon3,
      imageUrl: benefitImage2,
    },
    {
      id: "3",
      title: "Fast responding",
      text: "Lets users quickly find answers to their questions without having to search through multiple sources.",
      price: "S/30",

      backgroundUrl: "./src/assets/benefits/card-4.svg",
      iconUrl: benefitIcon4,
      imageUrl: benefitImage2,
      light: true,
    },
    {
      id: "4",
      title: "Ask anything",
      text: "Lets users quickly find answers to their questions without having to search through multiple sources.",
      price: "S/30",

      backgroundUrl: "./src/assets/benefits/card-5.svg",
      iconUrl: benefitIcon1,
      imageUrl: benefitImage2,
    },
    {
      id: "5",
      title: "Improve everyday",
      text: "The app uses natural language processing to understand user queries and provide accurate and relevant responses.",
      price: "S/30",

      backgroundUrl: "./src/assets/benefits/card-6.svg",
      iconUrl: benefitIcon2,
      imageUrl: benefitImage2,
    },
  ];
  export const collabText =
  "Si quieres alcanzar el nivel B2 y además te gustaría prepararte para el examen de Cambridge, este curso es para ti";

export const collabContent = [
  {
    id: "0",
    title: " Nos ajustamos a tu nivel actual y estilo de aprendizaje para garantizar que avances de manera efectiva.",
    text: collabText,
  },
  {
    id: "1",
    title: " Desde habilidades conversacionales hasta inglés técnico o académico, cubrimos lo que necesitas para triunfar.",
  },
  {
    id: "2",
    title: " Aprende con estrategias diseñadas para que logres resultados reales en el menor tiempo posible.",
  }
];



export const collabText2 =
"Sixxx quieres alcanzar el nivel B2 y además te gustaría prepararte para el examen de Cambridge, este curso es para ti";

export const collabContent2 = [
{
  id: "0",
  title: "20 Horas de Clases en Vivo",
  text: collabText2,
},
{
  id: "1",
  title: "Sábados y Domingos 4:00 - 6:00 pm",
},
{
  id: "2",
  title: "Ruta de Aprendizaje",
},
{
  id: "3",
  title: "S/.180 ",
}
];
  export const collabApps = [
    {
      id: "0",
      title: "Figma",
      icon: "https://flagsapi.com/GB/flat/64.png",
      width: 56,
      height: 36,
    },
    {
      id: "1",
      title: "Notion",
      icon: "https://flagsapi.com/FR/flat/64.png",
      width: 56,
      height: 36,
    },
    {
      id: "2",
      title: "Discord",
      icon: "https://flagsapi.com/JP/flat/64.png",
      width: 56,
      height: 28,
    },
    {
      id: "3",
      title: "Slack",
      icon: "https://flagsapi.com/PT/flat/64.png",
      width: 56,
      height: 35,
    },
    {
      id: "4",
      title: "Photoshop",
      icon: "https://flagsapi.com/US/flat/64.png",
      width: 56,
      height: 34,
    },
    {
      id: "5",
      title: "Protopie",
      icon: "https://flagsapi.com/CN/flat/64.png",
      width: 56,

      height: 34,
    },
    {
      id: "6",
      title: "Framer",
      icon: "https://flagsapi.com/DE/flat/64.png",
      width: 56,

      height: 34,
    },
    {
      id: "7",
      title: "Raindrop",
      icon: "https://flagsapi.com/IT/flat/64.png",
      width: 56,

      height: 32,
    },
  ];
  export const socials = [
    {
      id: "0",
      title: "Discord",
      iconUrl: discordBlack,
      url: "#",
    },
    {
      id: "1",
      title: "Twitter",
      iconUrl: twitter,
      url: "#",
    },
    {
      id: "2",
      title: "Instagram",
      iconUrl: instagram,
      url: "#",
    },
    {
      id: "3",
      title: "Telegram",
      iconUrl: telegram,
      url: "#",
    },
    {
      id: "4",
      title: "Facebook",
      iconUrl: facebook,
      url: "#",
    },
  ];
  export const brainwaveServices = [
    "Photo generating",
    "Photo enhance",
    "Seamless Integration",
  ];
  
  export const brainwaveServicesIcons = [
    recording03,
    recording01,
    disc02,
    chromecast,
    sliders04,
  ];
  export const roadmap = [
    {
      id: "0",
      title: "Reprogramaciones de Clase",
      text: "Si adquieres el paquete premium, puedes realizar reprogramaciones, recuerda que solo se permiten 2 reprogramaciones por paquete (cancelación el mismo día).  ",
      date: "PAQUETE PREMIUM",
      status: "done",
      imageUrl: roadmap1,
      colorful: true,
    },
    {
      id: "1",
      title: "Reprogramaciones de Clases",
      text: "Las reprogramaciones con anticipación son válidas siempre y cuando sean con al menos 1 día de anticipación. Las clases reprogramadas no se pierden; se pueden recuperar otro día, es decir, se agrega un día o los que sean necesarios  a tu paquete.",
      date: "PAQUETE PREMIUM",
      status: "progress",
      imageUrl: roadmap2,
      colorful: false,
    },
    {
      id: "2",
      title: "Uso del Roadmap",
      text: "Si adquieres el paquete con Roadmap, recuerda que se vence al terminar tu paquete de clases. No puedes revender el contenido. No está incluido en el paquete básico ni por clases individuales.",
      date: "May 2023",
      status: "done",
      imageUrl: roadmap3,
      colorful: true,
    },
    {
      id: "3",
      title: "Grabaciones de Clases",
      text: "Todos los videos y grabaciones se suben al canal de YouTube. Al ser un costo muy accesible para todos los beneficios y recursos, subirlos a un servidor elevaría los precios. Envía tu correo personal para que los videos solo puedan ser vistos desde esa cuenta. Si no envías tu correo, el video se publicará de forma pública y se te enviará el link.",
      date: "May 2023",
      status: "progress",
      imageUrl: roadmap4,
      colorful: false,
    },
    {
      id: "4",
      title: "Pagos",
      text: "Recuerda que si pagas por PayPal, debes agregar el impuesto. Todo pago se realiza antes de iniciar las clases.",
      date: "May 2023",
      status: "done",
      imageUrl: roadmap1, // Puedes cambiar la imagen si lo deseas
      colorful: true,
    },
  ];
  export const pricing = [
   
   
    {
      id: "1",
      title: "Paquete de Clases Premium ",
      description : "Este paquete de clases cuenta con 10 horas de clases en vivo ",
      price:  " 109 USD - 350 PEN ",
      price2:"20% off",
      price3: "Most Popular ",
description2: "Si eres de otro país , tu pago en dólares ya incluye el descuento de impuesto de USD$10 ",
image:"https://assets.revolut.com/media/plans-tiles/Cards-Tiles-Standard.png",

      features: [
        "Tu clase se graba y se envia por correo a cada correo   ",
        "Puedes hacer preguntas al profe por wsp directamente  ",
        "Acceso al Roadmap con Material Exclusivo",
        "Google Meet Premium",
        "Material de Estudio de cada clase",
        "Clases Personalizadas (decideden que quieren aprender)",
        "Hora peruana (GMT-5), previa entrevista",
      ],
    },
    {
      id: "1",
      title: "Paquete de Clases Basic ",
      description : "Este paquete de clases cuenta con 10 horas de clases en vivo ",
      price:  " 106 USD - 320 PEN ",
      price2:"20% off",
      price3: "Most Popular ",
description2: "Si eres de otro país , tu pago en dólares ya incluye el descuento de impuesto de USD$10 ",
image:"https://assets.revolut.com/media/plans-tiles/Cards-Tiles-Standard.png",

      features: [
        "Tu clase se graba y se envia por correo a cada correo   ",
        "Puedes hacer preguntas al profe por wsp directamente  ",
        "Google Meet Premium",
        "Material de Estudio de cada clase",
        "Clases Personalizadas (decideden que quieren aprender)",
        "Hora peruana (GMT-5), previa entrevista",
      ],
    },
    {
      id: "2",
      title: "B2 Cambridge Premium Plan (10 Hours) ",
      description : "En estas sesiones, podremos repasar y reforzar aspectos clave de la gramática, trabajar en el desarrollo de exámenes, practicar speaking y abordar todos los contenidos que forman parte del examen. Esto te permitirá mejorar tu rendimiento y sentirte más seguro al presentar la prueba.  ",
      price: "$/120-S/380 ",
      price2: "10% off",
      price3: "Most Popular ",

description2: "Si eres de otro país , tu pago en dólares ya incluye el descuento de impuesto de USD$10 ",
image:"https://assets.revolut.com/media/plans-tiles/Cards-Tiles-Standard.png",

      features: [
        "Tu clase se graba y se envia por correo a cada correo   ",
        "Puedes hacer preguntas al profe por wsp directamente  ",
        "Acceso al Roadmap con Material Exclusivo",
        "Google Meet Premium",
        "Material de Estudio de cada clase",
        "Clases Personalizadas (decideden que quieren aprender)",
        "Hora peruana (GMT-5), previa entrevista",
      ],
    },
    {
      id: "3",
      title: "Ielts Premium Plan (10 Hours) ",
      description : "Este paquete de clases cuenta con 10 horas de clases en vivo ",
      price: "$/120-S/380 ",
      price2: "10% off",
      price3: "Most Popular ",
description2: "Si eres de otro país , tu pago en dólares ya incluye el descuento de impuesto de USD$10 ",
image:"https://assets.revolut.com/media/plans-tiles/Cards-Tiles-Standard.png",

      features: [
        "Tu clase se graba y se envia por correo a cada correo   ",
        "Puedes hacer preguntas al profe por wsp directamente  ",
        "Acceso al Roadmap con Material Exclusivo",
        "Google Meet Premium",
        "Material de Estudio de cada clase",
        "Clases Personalizadas (decideden que quieren aprender)",
        "Hora peruana (GMT-5), previa entrevista",
      ],
    }
    
];
